import { toUserModel } from "~/helpers/utilHelper";
import { combineReducers } from "redux";
import {
  GET_AUTH_USER_OK,
  GET_AUTH_USER_ERR,
} from "./actionTypes";
import { TAction } from "~/types/global";
import User from "~/model/user";

/********** LOGIN **********/

type TLoginState = {
  user: User | null;
  userError: Error | null;
  isAuth: boolean | null;
}

const defaultLoginState: TLoginState = {
  user: null,
  userError: null,
  isAuth: null,
}

const Login = (state = defaultLoginState, action: TAction) => {
  switch (action.type) {
    case GET_AUTH_USER_OK:
      state = {
        ...state,
        isAuth: true,
        user: toUserModel(action.payload.response.user),
      };
      break
    case GET_AUTH_USER_ERR:
      state = {
        ...state,
        isAuth: false,
        userError: action.payload.error,
      };
      break
  }
  return state;
}

export default combineReducers({
  Login,
})
